<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>


            <el-col :span="12" class="item">
              <el-form-item label="机构" prop="institutionCode">
                <el-select @change="insChange"
                    v-model="addForm.institutionCode"
                    style="width:100%"
                    placeholder="请选择机构">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="评估类型" prop="checkinAssessClassCode">
                <el-select
                    v-model="addForm.checkinAssessClassCode"
                    style="width:100%"
                    placeholder="请选择评估类型">
                  <el-option
                      v-for="item in classData"
                      :key="item.checkinAssessClassCode"
                      :label="item.name"
                      :value="item.checkinAssessClassCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="评估组名称" prop="groupName">
                <el-input v-model="addForm.groupName" placeholder="请输入评估组名称"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="addForm.sort" placeholder="排序"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never' :body-style='{padding:0}'>
                <div slot="header" class="clearfix">
                  <span>评估项</span>
                  <el-button style="float: right;transform: translate(0px, -9px);" type="primary" @click="showModal">添加评估项</el-button>
                </div>
                <el-table
                    :data="itemInfo" :height="150"
                    style="width: 100%" border>
                  <el-table-column
                      prop="itemName"
                      label="评估项">
                  </el-table-column>
                  <el-table-column
                      prop="fraction"
                      label="分数">
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                      <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, itemInfo)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <el-dialog title='评估项添加' :visible.sync="batchDialog" class="dialog" width='400px'
               center top='30vh' :close-on-click-modal='false' :modal-append-to-body='false'>
      <el-form>
        <el-form-item label="评估项名称" required style="width:100%">
          <el-input v-model="itemName" placeholder="请输入评估项名称"></el-input>
        </el-form-item>
        <el-form-item label="分数" required style="width:100%">
          <el-input v-model="fraction" type="number" placeholder="请输入评估分数"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary"  @click="addSub">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Add",
  props:['arr_ins'],
  data() {
    return {

      loading: false,
      batchDialog: false,
      calculationType:1,
      pageSize: 20,
      currentPage: 1,
      assessItemInfo: [],
      itemInfo: [],
      itemName: null,
      fraction: null,

      addForm: {
        timeStr: timeStr,
        sign: '',
        staffCode: getStaffCode(),
        groupName: '',
        assessItemArr: [],
        sort: '',
        checkinAssessClassCode:'',
        institutionCode:'',
      },

      classData:[],

      rules: {
        groupName: [
          {required: true, message: '请输入评估组名称', trigger: 'blur'},
        ],
        checkinAssessClassCode: [
          {required: true, message: '请选择评估类型', trigger: 'blur'},
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'},
          {type: 'number', message: '排序必须为数字值'}
        ],
        institutionCode: [
          {required: true, message: '请选择机构', trigger: 'blur'},
        ],
      }


    }
  },

  methods: {
    init() {
      this.itemInfo=[]
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    addSubmit() {
      if(this.itemInfo.length==0){
        this.$message.error('请添加评估项')
        return
      }
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey);
      this.addForm.assessItemArr=this.itemInfo
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessGroup/GovAdd",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    showModal(){
      this.itemName=null
      this.fraction=null
      this.batchDialog=true
    },
    addSub(){
      if(!this.itemName){
        this.$message.error('请输入评估项名称')
        return
      }
      if(!this.fraction){
        this.$message.error('请输入评估分数')
        return
      }
      this.itemInfo.push({itemName:this.itemName,fraction:this.fraction})
      this.batchDialog=false
    },
    deleteRow(index, rows){
      rows.splice(index, 1);
    },


    insChange(val){
      this.addForm.institutionCode = val;

      this.classData=[];
      this.addForm.checkinAssessClassCode = '';
      this.getClass();
    },
    getClass(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessClass/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.classData = response.data.data;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });

    },




  }
}
</script>

<style lang="scss" scoped>




</style>
